import { useDetailPageBreadcrumbs } from 'shared/libs/hooks/useDetailPageBreadcrumbs'

import { useNavigate, useParams } from 'react-router-dom'

import UserInfo from 'modules/AccessManage/components/UserInfo'
import UserKeyAccess from 'modules/AccessManage/components/UserKeyAccess'
import { useUser } from 'modules/AccessManage/hooks/useUser'

import PrimaryButton from 'shared/ui/PrimaryButton'
import SkeletonNode from 'shared/ui/SkeletonNode'
import Title from 'shared/ui/Title'

const AccessManageUser = () => {
  const { userId } = useParams()
  const navigate = useNavigate()
  const { user, isGetUserFetching } = useUser({
    userId,
  })

  useDetailPageBreadcrumbs({
    key: 'userId',
    label: user?.full_name,
  })
  return (
    <div>
      <div className="flex justify-between items-center py-[12px]">
        <SkeletonNode
          loading={isGetUserFetching}
          className="!h-8 !w-full !max-w-96"
        >
          <Title
            className="!mb-0 !font-bold !leading-[32px] !text-dark_2"
            level={3}
          >
            {user?.full_name}
          </Title>
        </SkeletonNode>
        <PrimaryButton
          text="Редактировать"
          onClick={() => navigate('edit-user')}
        />
      </div>
      <div className="flex gap-[20px]">
        <UserInfo
          userInfo={user ?? null}
          isFetching={isGetUserFetching}
        />
        <UserKeyAccess
          mode="view"
          userInfo={user ?? null}
          isFetching={isGetUserFetching}
        />
      </div>
    </div>
  )
}

export default AccessManageUser
